<template>
  <div class="main-menu">
    <content-creator
      :settings="getBlobContents(menuName)"
      :permissions="contentCreatorPermissions"
      :is-visible="isEditable"
      :menu-style="menuStyle"
      :filestore="websitefilestore"
      :name="menuName"
      allowed-widgets="menu-editor"
      @updateBlob="(data) => saveBlob(menuName, data)"
    />
  </div>
</template>

<script>
import contentCreatorMixin from 'src/app/content-creator-mixin'

export default {
  name: 'main-menu',
  mixins: [
    contentCreatorMixin
  ],
  props: {
    menuStyle: {
      type: String,
      required: false,
      default: 'desktop'
    },
    menuName: {
      type: String,
      required: false,
      default: 'main-menu'
    }
  },
  data() {
    return {
    }
  },
  computed: {
    websitefilestore: function() {
      return this.$store.getters['filestore/filestoreInfo']('website')
    },
    isEditable: function() {
      if (this.menuStyle === 'desktop' && this.$store.getters['user/isLoggedIn'] && this.$store.getters['user/checkPermissions']('vuejs menu edit')) {
        return this.$store.state.flags['content-creator'] || false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
